import request from '@/utils/httpClient'

// 创建行政区域
export function createSysArea(data?: object) {
  return request({
    url: 'access',
    method: 'POST',
    data
  })
}

// 更新行政区域
export function updateSysArea(id: number, data?: object) {
  return request({
    url: `access/${id}`,
    method: 'put',
    data
  })
}

// 批量删除行政区域
export function deleteSysAreaById(id: number) {
  return request({
    url: `access/${id}`,
    method: 'delete'
  })
}

// 查找行政编号下的子节点行政地区，最小值为0
export function getSysAreaListByNo(superNo: number, params?: object) {
  return request({
    url: `sysArea/list/${superNo}`,
    method: 'get',
    params
  })
}
